import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from './http.service';

/**
 * Preferences belonging to the signed-in platform admin.
 *
 * Currently just the language used for admin-facing email (ticket assigned,
 * ticket escalated, daily platform summary). The dashboard's own UI language
 * lives in localStorage and is per-browser; this is the server-side copy, so
 * an admin who reads the dashboard in Dutch is also emailed in Dutch.
 */
@Injectable({
    providedIn: 'root'
})
export class AdminPreferencesService {
    private http = inject(HttpService);

    getPreferences(): Observable<any> {
        return this.http.get('/admin/me/preferences', 'ADMIN');
    }

    /**
     * Persist the admin's mail language. `null` clears the preference and
     * returns them to the platform fallback (English).
     *
     * `notify` is false: this rides along with the sidebar language switcher,
     * and a success toast for a preference the user did not explicitly submit
     * would be noise.
     */
    setLanguage(language: string | null): Observable<any> {
        return this.http.put('/admin/me/language', { language }, 'ADMIN', false);
    }
}
